// App Base URL

const APP_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://www.mototrad.com/api"
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "https://mototrad.com/"

//----------------------------------------------------    LOGIN URLS   --------------------------------------------------
// LOGIN API URL
export const LOGIN_API_URL = APP_BASE_URL + "/admin/login"



//----------------------------------------------------    REGISTER URLS   --------------------------------------------------
// REGISTER API URL
export const REGISTER_API_URL = APP_BASE_URL + "/register"



//----------------------------------------------------    CATEGORIES URLS   --------------------------------------------------
// Category List URL
export const CATEGORY_LIST_URL = APP_BASE_URL + "/admin/categories/list"

// Category Create  URL
export const CATEGORY_ADD_URL = APP_BASE_URL + "/admin/categories/create"

// Product Details  URL
export const CATEGORY_DETAILS_URL = APP_BASE_URL + "/admin/categories"

// Category Delete URL
export const CATEGORY_DELETE_URL = APP_BASE_URL + "/admin/categories"

// Category Update URL
export const CATEGORY_UPDATE_URL = APP_BASE_URL + "/admin/categories"

// Category Image URL
export const CATEGORY_IMAGE_URL = IMAGE_BASE_URL + "/uploads/categories";



//----------------------------------------------------    PRODUCTS URL   ------------------------------------------------------
// Product List  URL
export const PRODUCT_LIST_URL = APP_BASE_URL + "/admin/products/list"

// Product Create  URL
export const PRODUCT_ADD_URL = APP_BASE_URL + "/admin/products/create"

// Product Details  URL
export const PRODUCT_DETAILS_URL = APP_BASE_URL + "/admin/products"

// Product Update  URL
export const PRODUCT_UPDATE_URL = APP_BASE_URL + "/admin/products"

// Product Delete URL
export const PRODUCT_DELETE_URL = APP_BASE_URL + "/admin/products"

// Product Image URL
export const PRODUCT_IMAGE_URL = IMAGE_BASE_URL + "/uploads/products";

// Product Gallery Images URL
export const PRODUCT_GALLERY_IMAGES_URL = APP_BASE_URL + "/admin/products/images";

// Product Upload Gallery Image URL
export const PRODUCT_UPLOAD_IMAGE_URL = APP_BASE_URL + "/admin/products/upload";

// Product Associate Gallery Image URL
export const PRODUCT_ASSOCIATE_IMAGE_URL = APP_BASE_URL + "/admin/products/associate";

// Product Delete Gallery Image URL
export const PRODUCT_DELETE_IMAGE_URL = APP_BASE_URL + "/admin/products/delete/image";




//----------------------------------------------------    USERS URL   ------------------------------------------------------
// User List  URL
export const USERS_LIST_URL = APP_BASE_URL + "/admin/users/list"

// User Create URL
export const USER_CREATE_URL = APP_BASE_URL + "/admin/users/create";

// User Details URL
export const USER_DETAILS_URL = APP_BASE_URL + "/admin/users";

// User Update URL
export const USER_UPDATE_URL = APP_BASE_URL + "/admin/users";

// User Image URL
export const USER_IMAGE_URL = IMAGE_BASE_URL + "/uploads/users/";

// User Delete URL
export const USER_DELETE_URL = APP_BASE_URL + "/admin/users";




//----------------------------------------------------    BIDS URL   ------------------------------------------------------
// Bids List URL
export const BIDS_LIST_URL = APP_BASE_URL + "/admin/bids/list"

// Bids Delete URL - 
export const BIDS_DELETE_URL = APP_BASE_URL + "/admin/bids"

// Bids Details URL - 
export const BIDS_DETAILS_URL = APP_BASE_URL + "/admin/bids"


//----------------------------------------------------    ORDERS URL   ------------------------------------------------------
// Orders List URL - CUSTOMER/ADMIN
export const ORDERS_LIST_URL = APP_BASE_URL + "/admin/orders/list"

// Orders Details URL - 
export const ORDERS_DETAILS_URL = APP_BASE_URL + "/admin/orders"

// Orders Delete URL - 
export const ORDERS_DELETE_URL = APP_BASE_URL + "/admin/orders/delete"

// Orders Status Update URL - 
export const ORDERS_STATUS_UPDATE_URL = APP_BASE_URL + "/admin/orders/status/update"

// Orders Invoice URL - 
export const ORDERS_INVOICE_SENT_URL = APP_BASE_URL + "/admin/orders/send/invoice"



//----------------------------------------------------    Is Live URL   ------------------------------------------------------

// product Live - 
export const PRODUCT_LIVE_URL = APP_BASE_URL + "/admin/products/make/live"


//----------------------------------------------------    General Setting   ------------------------------------------------------

// General Setting Post Url  - 
export const GENERAL_SETTING_POST_URL = APP_BASE_URL + "/admin/general/update/settings"



// General Setting Get Url  - 
export const GENERAL_SETTING_GET_URL = APP_BASE_URL + "/admin/general/settings"

//----------------------------------------------------    Dashboard KPIs   ------------------------------------------------------

// Home page KPIS list  - 
export const DASHBOARD_KPIS = APP_BASE_URL + "/admin/dashboard/kpis"


